import React from 'react';

import GameLibrary from '@/components/common/libraries/GamesLibrary';

interface GameProps {
  program: {
    id: string,
    display_investigations: boolean,
    display_unit_content: boolean,
    science: boolean,
    referenceTextLabel: string,
  };
  lesson?: {
    id: string;
  };
  unit?: {
    id: string;
  };
  gradeUri: string;
}

const Games = ({ program, lesson, unit, gradeUri }: GameProps) => (
  <GameLibrary
    gradeUri={gradeUri}
    lesson={lesson}
    program={program}
    unit={unit}
  />
);

export default Games;
